<template>
    <div class="error-msg-wrap">
        <div v-if="loaded && !showSub" class="form-wrapper slide-up" :style="resendLoading ? 'width:800px;opacity: .5;pointer-events:none' : 'width:800px'">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div style="display:flex;flex-wrap: wrap">
                <select v-if="formToView.AdminContinueSubmissionFormID" v-model="finished" @change="search()" style="margin-right: 10px;width: 120px">
                    <option :value="false">Unfinished</option>
                    <option :value="true">Finished</option>
                </select>
                <input type="text" v-model="searchQ" @input="search()" placeholder="Search" style="width: 180px" />
            </div>
            <table class="full-table">
                <tr v-for="(sub, i) in submissions" :key="i">
                    <td>{{ sub.CreatedDisplay }}</td>
                    <td><a @click.prevent="viewSub(sub)">{{ sub.SignatureDisplay }}</a></td>
                    <td v-if="formToView.AdminContinueSubmissionFormID"><a :href="`/team-hub?formID=${formToView.AdminContinueSubmissionFormID}&previousSubmissionID=${sub.ID}`" target="_blank">Finish</a></td>
                    <td><a @click.prevent="resendSub(sub)">Resend Email</a></td>
                </tr>
            </table>
        </div>

        <div v-if="showSub" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { showSub = false }">&times;</button>
            </div>
            <div style="margin-bottom:15px;" v-if="formToView.AdminContinueSubmissionFormID"><a :href="`/team-hub?formID=${formToView.AdminContinueSubmissionFormID}&previousSubmissionID=${subToShow.id}`" target="_blank" class="primary" style="font-weight:bold">Finish</a></div>
            <div v-for="(field, i) in subToShow.fields" :key="i">
                <div v-if="field.type == 'multiplefiles' && field.values?.length" style="margin-bottom:10px">
                    <div><b>{{ field.label }}:</b></div>
                    <div v-for="(url, n) in field.values" :key="i + '_' + n">
                        <a :href="url" target="_blank">Download File</a>
                    </div>
                </div>
                <div v-else-if="field.value" style="margin-bottom:10px">
                    <div v-if="field.type == 'file'">
                        <div><b>{{ field.label }}:</b> <a :href="field.value" target="_blank">Download File</a></div>
                    </div>
                    <div v-else-if="field.type == 'textarea'"><b>{{ field.label }}:</b><br/><div v-html="field.value.replace(/\n/g, '<br/>')"></div></div>
                    <div v-else-if="field.type == 'signature'">
                        <div><b>{{ field.label }}:</b></div>
                        <img :src="field.value" />
                    </div>
                    <div v-else><b>{{ field.label }}:</b> {{ field.value }}</div>
                </div>
            </div>
            <div>
                <div><b>Signature:</b></div>
                <div><img :src="subToShow.signatureData" /></div>
                <div>{{ subToShow.signature }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'FormViewSubmissions',
    props: [ 'formToView' ],
    components: {
        
    },
    data() {
        return {
            allSubmissions: [] as any,
            submissions: [] as any,
            loaded: false,
            showSub: false,
            subToShow: {} as any,
            finished: false, 
            searchQ: '',
            resendLoading: false
        }
    },
    async created() {
        await this.getSubmissions();

        if(this.$route.query.submissionID) {
            const sub = this.submissions.find((s: any) => {
                return s.ID == this.$route.query.submissionID;
            });
            if(sub) {
                this.viewSub(sub);
            }
        }

        this.loaded = true;
    },
    methods: {
        async getSubmissions() {
            await axios.get(`${this.$store.state.apiUrl}/api/forms/submissions/${this.formToView.ID}`)
                .then(resp => {
                    for(const sub of resp.data) {
                        sub.CreatedDisplay = new Date(sub.Created).toLocaleDateString();
                        sub.SignatureDisplay = sub.Signature;
                        // Show first name field instead for SuperForm
                        if(this.$store.state.user.companyID == 1) {
                            const firstNameField = JSON.parse(sub.FieldsJSON).find((f: any) => {
                                return f.label.includes('Name');
                            })
                            if(firstNameField && firstNameField.value) {
                                sub.SignatureDisplay = firstNameField.value;
                            }
                        }
                    }
                    this.allSubmissions = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })

            this.search();
        },
        viewSub(sub: any) {
            const nonSensitiveFields = JSON.parse(sub.FieldsJSON).filter((f: any) => {
                return !f.sensitive;
            })
            this.subToShow = {
                id: sub.ID,
                fields: nonSensitiveFields,
                signature: sub.Signature,
                signatureData: sub.SignatureData
            }
            this.showSub = true;
        },
        search() {
            let tempSubmissions = this.allSubmissions;
            if(this.formToView.AdminContinueSubmissionFormID) {
                if(this.finished) {
                    tempSubmissions = tempSubmissions.filter((s: any) => {
                        return s.FormFinished;
                    })
                } else {
                    tempSubmissions = tempSubmissions.filter((s: any) => {
                        return !s.FormFinished;
                    })
                }
            }
            if(this.searchQ.length > 3) {
                const searchQLower = this.searchQ.toLowerCase();
                tempSubmissions = tempSubmissions.filter((s: any) => {
                    return s.Signature && s.Signature.toLowerCase().includes(searchQLower);
                })
            }
            this.submissions = tempSubmissions;
        },
        async resendSub(sub: any) {
            this.resendLoading = true;
            const data = {
                id: sub.ID,
                formID: this.formToView.ID
            }
            await axios.post(`${this.$store.state.apiUrl}/api/forms/resendemail`, data)
                .then(resp => {
                    alert('Email sent to form recipients');
                })
                .catch(e => {
                    alert(e?.response?.data || 'There was an error');
                })
            this.resendLoading = false;
        }
    }
});
</script>
